import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { MessageList } from "../config/Message";

interface ChatState {
  messageList: MessageList[];
  chatHistory: any[];
  activeChatId: string | null;
}

const initialState: ChatState = {
  messageList: [],
  chatHistory: [],
  activeChatId: null,
};

const chatSlice = createSlice({
  name: "chat",
  initialState,
  reducers: {
    setMessageList(state, action: PayloadAction<MessageList[]>) {
      state.messageList = action.payload;
    },
    setChatHistory(state, action: PayloadAction<any[]>) {
      state.chatHistory = action.payload;
    },
    addMessage(state, action: PayloadAction<any>) {
      state.chatHistory.push(action.payload);
    },
    setActiveChatId(state, action: PayloadAction<string | null>) {
      state.activeChatId = action.payload;
    },

    clearChatData(state) {
      state.messageList = [];
      state.chatHistory = [];
      state.activeChatId = null;
    },
  },
});

export const { setMessageList, setChatHistory, addMessage, setActiveChatId,clearChatData } =
  chatSlice.actions;

export default chatSlice.reducer;
